module.exports = __webpack_public_path__ + "static/media/icon store.c97dd931.png";